/*
* Broadcast Theme — custom.js
* - Bloquea la auto-apertura del cart drawer tras añadir al carrito.
* - Microinteracción visible en el header: bump del badge + bounce del icono.
*/

(function () {
  // ===============================
  // 0) Estilos inyectados
  // ===============================
  function injectStylesOnce() {
    if (document.getElementById('oc-cart-anim-style')) return;
    const s = document.createElement('style');
    s.id = 'oc-cart-anim-style';
    s.textContent = `
      /* POP del numerito */
      .cart-badge-bump { animation: cartBadgeBump 550ms cubic-bezier(.2,.8,.2,1); }
      @keyframes cartBadgeBump {
        0%   { transform: scale(1); box-shadow: 0 0 0 rgba(0,0,0,0); }
        30%  { transform: scale(1.25); box-shadow: 0 0 0 6px rgba(0,0,0,.06); }
        60%  { transform: scale(0.95); box-shadow: 0 0 0 2px rgba(0,0,0,.05); }
        100% { transform: scale(1); box-shadow: 0 0 0 rgba(0,0,0,0); }
      }

      /* Bounce del enlace del carrito */
      .cart-icon-bounce { animation: cartIconBounce 600ms cubic-bezier(.34,1.56,.64,1); }
      @keyframes cartIconBounce {
        0%   { transform: translateY(0); }
        30%  { transform: translateY(-6px); }
        60%  { transform: translateY(0); }
        80%  { transform: translateY(-2px); }
        100% { transform: translateY(0); }
      }

      /* Asegura que el badge es animable y legible */
      a[data-cart-toggle] cart-count.header__cart__status {
        display: inline-flex; align-items: center; justify-content: center;
        min-width: 1.25em; min-height: 1.25em; padding: 0 .25em; border-radius: 999px;
        will-change: transform, box-shadow;
      }

      /* Respeto a usuarios con reduce motion */
      @media (prefers-reduced-motion: reduce) {
        .cart-badge-bump, .cart-icon-bounce { animation: none !important; }
      }
    `;
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectStylesOnce);
  else injectStylesOnce();

  // ===============================
  // 1) Selectores del header (móvil + desktop)
  // ===============================
  function getCartToggles() {
    // Hay uno en móvil y otro en desktop; devolvemos ambos si existen
    return Array.from(document.querySelectorAll('a[data-cart-toggle]'));
  }
  function getCartBadges() {
    // El badge que dibuja tu header
    return Array.from(document.querySelectorAll('a[data-cart-toggle] cart-count.header__cart__status'));
  }

  // ===============================
  // 2) Utilidad para animar
  // ===============================
  function animate(el, className) {
    if (!el) return;
    el.classList.remove(className);
    // reflow para reiniciar animación si se repite rápido
    void el.offsetWidth;
    el.classList.add(className);
    el.addEventListener('animationend', function handler() {
      el.classList.remove(className);
      el.removeEventListener('animationend', handler);
    });
  }

  function runCartMicrointeraction() {
    const badges = getCartBadges();
    const toggles = getCartToggles();
    badges.forEach(b => animate(b, 'cart-badge-bump'));
    // bounce suave del enlace; si prefieres solo el badge, comenta la línea de abajo
    toggles.forEach(t => animate(t, 'cart-icon-bounce'));
  }

  // ===============================
  // 3) Disparadores fiables del tema
  // ===============================
  // Broadcast emite esto siempre que cambia el carrito (lo usa <cart-count>)
  document.addEventListener('theme:cart:change', runCartMicrointeraction, false);

  // Por compatibilidad con apps/quick add alternativos
  ['cart:after-add', 'added-to-cart', 'ajaxProduct:added'].forEach(evt => {
    document.addEventListener(evt, runCartMicrointeraction, false);
  });

  // ===============================
  // 4) Mantener el drawer cerrado tras AddToCart (como querías)
  // ===============================
  // El tema abre el drawer al escuchar "theme:product:added".
  // Lo bloqueamos en CAPTURA para que no llegue a su listener.
  document.addEventListener('theme:product:added', function (e) {
    e.stopImmediatePropagation();
  }, true);
})();

/* ==========================================================================
   O&C | PDP sticky Add to Cart visibility
   Shows Broadcast cart bar whenever the main PDP Add to Cart is not visible
   ========================================================================== */

class ProductCartBarVisibility extends HTMLElement {
  connectedCallback() {
    this.productSection = this.closest('[data-section-type="product"]');

    if (!this.productSection) return;

    this.cartBar = this.productSection.querySelector('#cart-bar');

    this.mainAddToCart = this.productSection.querySelector(
      '[data-product-form] [data-add-to-cart]'
    );

    if (!this.cartBar || !this.mainAddToCart) return;

    this.handleResize = this.handleResize.bind(this);

    this.initObserver();

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.cartBar);
    }

    document.addEventListener('theme:resize', this.handleResize);
  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    document.removeEventListener('theme:resize', this.handleResize);

    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame);
    }
  }

  handleResize() {
    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame);
    }

    this.resizeFrame = requestAnimationFrame(() => {
      this.initObserver();
    });
  }

  initObserver() {
    if (!this.mainAddToCart || !this.cartBar) return;

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    const cartBarHeight = Math.ceil(
      this.cartBar.getBoundingClientRect().height
    );

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        const buttonVisible =
          entry.isIntersecting &&
          entry.intersectionRatio > 0;

        this.cartBar.classList.toggle(
          'is-visible-by-button',
          !buttonVisible
        );
      },
      {
        root: null,
        rootMargin: `0px 0px -${cartBarHeight}px 0px`,
        threshold: [0, 0.01]
      }
    );

    this.intersectionObserver.observe(this.mainAddToCart);
  }
}

if (!customElements.get('product-cart-bar-visibility')) {
  customElements.define(
    'product-cart-bar-visibility',
    ProductCartBarVisibility
  );
}

/* ===============================

(function () {
  function cleanEUR() {
    document.querySelectorAll('.new-price, .price, del, span').forEach(el => {
      if (!el || !el.textContent) return;

      if (el.childNodes.length === 0) return;

      el.childNodes.forEach(node => {
        if (node.nodeType === 3) {
          node.textContent = node.textContent
            .replace(/EUR/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();
        }
      });
    });
  }

  cleanEUR();

  let i = 0;
  const timer = setInterval(() => {
    cleanEUR();
    i++;
    if (i > 12) clearInterval(timer); // ~6 seconds
  }, 500);
})();

/* ===============================
   Discount field logic
   - Generic discount codes
   - Special EASTERGIFT handling
   - Drawer: reload current page
   - Cart page: redirect to /cart

(function () {
  if (window.CartDiscountField) return;

  window.CartDiscountField = {
    GIFT_CODE: 'EASTERGIFT',
    GIFT_VARIANT_ID: 49566701224265,
    GIFT_SKU: 'L-EGGPLANT-CAR',
    MINIMUM_AMOUNT_CENTS: 6000,

    getStrings(root) {
      return {
        enterCode: root.dataset.enterCodeText || 'Please enter a code.',
        invalidCode: root.dataset.invalidCodeText || 'This code is not valid.',
        minimumNotReached: root.dataset.minimumNotReachedText || 'This reward requires a minimum order amount.',
        giftAdded: root.dataset.giftAddedText || 'Gift added to cart.',
        applyError: root.dataset.applyErrorText || 'Something went wrong. Please try again.',
        removeError: root.dataset.removeErrorText || 'We could not remove the code. Please try again.',
        removeText: root.dataset.removeText || 'Remove'
      };
    },

    async getCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(r => r.json());
    },

    async updateCartAttributes(attributes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes })
      });
    },

    async addGift() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: this.GIFT_VARIANT_ID,
              quantity: 1
            }
          ]
        })
      });
    },

    async removeGift(cart) {
      const gift = cart.items.find(item =>
        item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
      );

      if (!gift) return;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: gift.key,
          quantity: 0
        })
      });
    },

    isDrawer(element) {
      return !!element.closest('cart-drawer');
    },

    currentPageRedirectUrl() {
      return window.location.pathname + window.location.search;
    },

    setMessage(messageEl, text, type) {
      if (!messageEl) return;
      messageEl.textContent = text || '';
      messageEl.classList.remove('is-error', 'is-success');
      if (type) messageEl.classList.add(type);
    },

    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    async validateNormalCode(code) {
      try {
        const beforeCart = await this.getCart();
        const beforeTitles = (beforeCart.cart_level_discount_applications || []).map(d => (d.title || '').toUpperCase());

        await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
          credentials: 'same-origin'
        });

        const afterCart = await this.getCart();
        const afterTitles = (afterCart.cart_level_discount_applications || []).map(d => (d.title || '').toUpperCase());

        return afterTitles.includes(code) || (!beforeTitles.includes(code) && afterTitles.length > beforeTitles.length);
      } catch (e) {
        return false;
      }
    },

    async apply(button) {
      const root = button.closest('[data-cart-discount-field]');
      if (!root) return;

      const input = root.querySelector('.cart-discount__input');
      const message = root.querySelector('[data-cart-discount-message]');
      const code = (input?.value || '').trim().toUpperCase();
      const inDrawer = this.isDrawer(root);
      const strings = this.getStrings(root);

      this.setMessage(message, '');

      if (!code) {
        this.setMessage(message, strings.enterCode, 'is-error');
        return;
      }

      // Special gift code
      if (code === this.GIFT_CODE) {
        try {
          const cart = await this.getCart();

          if (cart.total_price < this.MINIMUM_AMOUNT_CENTS) {
            this.setMessage(message, strings.minimumNotReached, 'is-error');
            return;
          }

          const alreadyInCart = cart.items.some(item =>
            item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
          );

          await this.updateCartAttributes({
            easter_reward_code: code
          });

          if (!alreadyInCart) {
            await this.addGift();
          }

          if (inDrawer) {
            window.location.href =
              '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
            return;
          }

          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          return;

        } catch (error) {
          this.setMessage(message, strings.applyError, 'is-error');
          return;
        }
      }

      // Generic codes
      if (inDrawer) {
        const valid = await this.validateNormalCode(code);

        if (!valid) {
          this.setMessage(message, strings.invalidCode, 'is-error');
          return;
        }

        window.location.href =
          '/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
        return;
      }

      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    },

    async remove(button) {
      const root = button.closest('[data-cart-discount-field]');
      if (!root) return;

      const message = root.querySelector('[data-cart-discount-message]');
      const inDrawer = this.isDrawer(root);
      const strings = this.getStrings(root);

      this.setMessage(message, '');

      try {
        const cart = await this.getCart();

        const hasGift = cart.items.some(item =>
          item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
        );

        if (hasGift) {
          await this.removeGift(cart);
        }

        await this.updateCartAttributes({
          easter_reward_code: ''
        });

        if (inDrawer) {
          window.location.href =
            '/discount/none?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
          return;
        }

        window.location.href = '/discount/none?redirect=/cart';

      } catch (error) {
        this.setMessage(message, strings.removeError, 'is-error');
      }
    }
  };
})();
/* ===============================
   Discount Hunt -> Klaviyo bridge
   - Detect reward popup
   - Save code in localStorage
   - Copy code to clipboard
   - Open Klaviyo form by reward code and locale

(function () {
  const ROOT_SELECTOR = '#discounthuntapp-root';
  const CODE_SELECTOR = '#ff-discounthunt-session-modal__body ._resultDiscountCode_yj2h2_25';

  const STORAGE_CODE = 'oc_discount_hunt_code';
  const STORAGE_LAST_TRIGGERED = 'oc_discount_hunt_last_triggered';

  const DEBUG = true;

  const REWARD_CONFIG = {
    EASTER15: {
      forms: {
        en: 'WCBZJq',
        es: 'VMA5W9',
        fr: 'VjH3Yj',
        it: 'STymLS'
      },
      type: 'discount',
      minimum: 'Valid on orders over €60'
    },

    EASTER10: {
      forms: {
        en: 'WCe9w2',
        es: 'WuD8RN',
        fr: 'TaK8VK',
        it: 'UrvecP'
      },
      type: 'discount',
      minimum: 'Valid on orders over €60'
    },

    EASTERGIFT: {
      forms: {
        en: 'W4wRd8',
        es: 'UYHgAn',
        fr: 'RjGZep',
        it: 'Xwzt9r'
      },
      type: 'gift',
      minimum: 'Valid on orders over €60'
    }
  };

  function log() {
    if (!DEBUG) return;
    console.log('[DiscountHunt -> Klaviyo]', ...arguments);
  }

  function getCurrentLocale() {
    const raw =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      'en';

    const locale = String(raw).toLowerCase().split('-')[0];
    return ['en', 'es', 'fr', 'it'].includes(locale) ? locale : 'en';
  }

  function saveReward(code) {
    const reward = REWARD_CONFIG[code] || null;

    localStorage.setItem(STORAGE_CODE, code);

    if (reward) {
      localStorage.setItem('oc_discount_hunt_reward_type', reward.type);
      localStorage.setItem('oc_discount_hunt_reward_minimum', reward.minimum);
    }

    log('Saved reward:', code, reward);
  }

  async function copyCode(code) {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      log('Copied code to clipboard:', code);
    } catch (e) {
      log('Clipboard copy failed:', e);
    }
  }

  function tryOpenKlaviyoForm(formId) {
    if (!formId) return false;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    log('Tried _klOnsite.push openForm:', formId);

    if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
      try {
        window._klOnsite.openForm(formId);
        log('Tried _klOnsite.openForm:', formId);
      } catch (e) {
        log('_klOnsite.openForm failed:', e);
      }
    }

    return true;
  }

  function openKlaviyoForm(code) {
    const reward = REWARD_CONFIG[code];
    if (!reward || !reward.forms) {
      log('No reward config found for code:', code);
      return;
    }

    const locale = getCurrentLocale();
    const formId = reward.forms[locale] || reward.forms.en;

    if (!formId) {
      log('No form ID found for code/locale:', code, locale);
      return;
    }

    const lastTriggered = sessionStorage.getItem(STORAGE_LAST_TRIGGERED);
    if (lastTriggered === `${code}_${locale}`) {
      log('Already triggered this session:', code, locale);
      return;
    }

    sessionStorage.setItem(STORAGE_LAST_TRIGGERED, `${code}_${locale}`);
    log('Opening form for:', code, 'locale:', locale, 'formId:', formId);

    // Intento inmediato
    tryOpenKlaviyoForm(formId);

    // Fallback retrasado por si Klaviyo.js aún no estaba listo
    setTimeout(function () {
      tryOpenKlaviyoForm(formId);
    }, 600);
  }

  function handleDiscountHuntPopup(root) {
    if (!root) return;

    const codeEl = root.querySelector(CODE_SELECTOR);
    if (!codeEl) {
      log('Popup found but no code element found');
      return;
    }

    const code = (codeEl.textContent || '').trim().toUpperCase();
    if (!code) {
      log('Code element empty');
      return;
    }

    log('Detected code:', code);

    saveReward(code);
    copyCode(code);
    openKlaviyoForm(code);
  }

  function initDiscountHuntObserver() {
    log('Initializing observer');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          const popupRoot =
            node.matches?.(ROOT_SELECTOR)
              ? node
              : node.querySelector?.(ROOT_SELECTOR);

          if (popupRoot) {
            log('Popup root detected');
            handleDiscountHuntPopup(popupRoot);
            return;
          }

          const codeEl = node.matches?.(CODE_SELECTOR)
            ? node
            : node.querySelector?.(CODE_SELECTOR);

          if (codeEl) {
            log('Code element detected directly');
            handleDiscountHuntPopup(document);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountHuntObserver);
  } else {
    initDiscountHuntObserver();
  }
})();


(function () {
  'use strict';

  if (!location.pathname.includes('/collections/')) return;

  var timer = null;
  var lastMoneyCount = 0;

  function getProductJsonForItem(item) {
    var prev = item.previousElementSibling;

    if (prev && prev.matches('.bold-product-json')) {
      try {
        return JSON.parse(prev.textContent);
      } catch (e) {
        return null;
      }
    }

    return null;
  }

  function hydrateBoldHooks() {
    document.querySelectorAll('.product-item').forEach(function (item) {
      var product = getProductJsonForItem(item);
      if (!product || !product.id || !product.variants || !product.variants.length) return;

      var variant = product.variants[0];
      var priceEl = item.querySelector('.product-item__price .price');
      if (!priceEl) return;

      priceEl.classList.add('money');
      priceEl.setAttribute('data-product-id', product.id);
      priceEl.setAttribute('data-product-handle', product.handle);
      priceEl.setAttribute('data-variant-id', variant.id);
      priceEl.style.visibility = 'visible';
      priceEl.style.opacity = '1';
    });
  }

  function triggerBold() {
    hydrateBoldHooks();

    var moneyCount = document.querySelectorAll('.product-item__price .money').length;
    if (!moneyCount || moneyCount === lastMoneyCount) return;

    lastMoneyCount = moneyCount;

    console.log('[O&C Bold] triggering after collection update:', moneyCount);

    window.dispatchEvent(new Event('load'));
    document.dispatchEvent(new Event('DOMContentLoaded'));

    if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
      window.BOLD.common.eventEmitter.emit('BOLD_COMMON_collection_loaded');
      window.BOLD.common.eventEmitter.emit('BOLD_COMMON_product_loaded');
    }
  }

  function scheduleBoldTrigger() {
    clearTimeout(timer);

    setTimeout(triggerBold, 300);
    setTimeout(triggerBold, 900);
    setTimeout(triggerBold, 1800);
    timer = setTimeout(triggerBold, 3000);
  }

  document.addEventListener('theme:pagination:updated', scheduleBoldTrigger);
  document.addEventListener('theme:collection:updated', scheduleBoldTrigger);

  var target = document.getElementById('CollectionLoop') || document.body;

  new MutationObserver(function () {
    scheduleBoldTrigger();
  }).observe(target, {
    childList: true,
    subtree: true
  });

  scheduleBoldTrigger();
})();
================================= */
